// Make this work with data element instead of Id
const ToggleDisabled = {
	init() {
		const toggles = document.querySelectorAll('.js-toggle-disabled');
		if (toggles != null && toggles.length > 0) {
			toggles.forEach((item) => item.addEventListener('click', this.toggleDisabled));
		}
	},

	toggleDisabled(event) {
		const elementToToggleId = event?.target?.dataset?.toggleElementId;
		if (elementToToggleId) {
			const elementToToggle = document.getElementById(elementToToggleId);
			if (elementToToggle) elementToToggle.disabled = !elementToToggle.disabled;
		}
	},
};

export { ToggleDisabled as default };
